import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  viewBox: "0 0 25 26",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M21.088 23.154a1.562 1.562 0 0 0 1.562-1.561V2.063a1.563 1.563 0 1 0-3.125 0v1.112l-16.4 3.938v-.364A1.562 1.562 0 1 0 0 6.75v10.152a1.563 1.563 0 0 0 3.125 0v-.363l3.125.753v3.38a4.777 4.777 0 0 0 4.234 4.8 4.687 4.687 0 0 0 5.14-4.669v-1.26l3.906.936v1.113a1.562 1.562 0 0 0 1.558 1.563Zm-8.592-2.343a1.563 1.563 0 0 1-3.125 0v-2.77l3.125.75v2.02Zm-9.374-7.48v-3.008l16.4-3.937V17.27l-16.4-3.937Z",
      fill: "#E6ACAA"
    }, null, -1)
  ]))]))
}
export default { render: render }